import { createButton } from './buttons_utils';
import { createTooltip } from './tooltips_utils';
import { checkClipboardPermissions } from './utils';

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

class CopyCodeElement extends HTMLElement {
  constructor() {
    super();
    _defineProperty(this, "getCodeElement", () => {
      const wrapper = this.parentNode;
      return wrapper.getElementsByTagName('code')[0] || wrapper.getElementsByTagName('pre')[0];
    });
    this.initialize();
  }
  async initialize() {
    if (!this.getCodeElement()) return;
    const btn = createButton('Copy to clipboard', 'copy-to-clipboard');
    this.appendChild(btn);
    const tooltip = await createTooltip(btn, 'Copy to clipboard');
    this.appendChild(tooltip);
    btn.addEventListener('click', async () => {
      // We fetch the code element on click instead because the structure of the HTML can change after
      // the element is initialized (e.g. on sanitation), and we don't want to use an element that is
      // not present in the DOM.
      const codeElement = this.getCodeElement();
      const textToCopy = codeElement.innerText;
      const hasClipboardPermission = await checkClipboardPermissions();
      try {
        codeElement.dispatchEvent(new CustomEvent('copy-code-snippet', {
          bubbles: true,
          cancelable: true,
          detail: {
            code: textToCopy
          }
        }));
        if (hasClipboardPermission) {
          await navigator.clipboard.writeText(textToCopy);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Failed to copy snippet:', e);
      }
    });
  }
}

export { CopyCodeElement };
